import { IonButton, IonIcon } from '@ionic/react'
import { copyOutline } from 'ionicons/icons'

import { useClipboard } from '../../../hooks/use-clipboard'

type Props = { clipboard: string; disabled?: boolean; message?: string }

function CopyButton({ clipboard, disabled, message = 'Copied!' }: Props) {
  const { copyToClipboard } = useClipboard()

  return (
    <IonButton
      color="secondary"
      fill="clear"
      size="small"
      disabled={disabled}
      onClick={() => copyToClipboard(clipboard, message)}
    >
      <IonIcon icon={copyOutline} slot="icon-only" />
    </IonButton>
  )
}
export { CopyButton }
